import { OptionsItemLiveData, OptionsItemLocData, TextStatesData, TextureStatesData } from "../../../types/types";
import { ApplyMixins } from "../../../utils/ApplyMixins";
import { Interactive } from "../../../mixins/Interactive";
import { Showable } from "../../../mixins/Showable";
import { UpdateView } from "../../../mixins/UpdateView";
import { ISize } from "../../../controls/scrollpane/ISize";
import { RectSize } from "../../../utils/RectSize";
import { OptionsItemBase } from "./OptionsItemBase";
import { LoaderFileKeys } from "../../constant/AppConstants";
import isMobile from 'ismobilejs';

export interface OptionsButtonItem extends Showable, Interactive, UpdateView { }

export class OptionsButtonItem
    extends OptionsItemBase
    implements ISize {
    public buttonBg: Phaser.GameObjects.NineSlice;
    private static appliedMixins: boolean = false;
    protected onItemButtonClick: Function;

    public Init(
        bgTextureStates: TextureStatesData,
        labelTextStates: TextStatesData,
        onItemButtonClick: Function,
        delimiterLineAlpha: number,
    ): void {
        if (!OptionsButtonItem.appliedMixins) {
            ApplyMixins(OptionsButtonItem, [Showable, UpdateView]);
            OptionsButtonItem.appliedMixins = true;
        }

        this.onItemButtonClick = onItemButtonClick;
        this.delimiterLineAlpha = delimiterLineAlpha;

        this.updateViews = [];
        this.size = new RectSize();
        this.isShowing = false;
        this.pointerOver = false;

        const _isMobile: boolean = isMobile(window.navigator).any;

        this.bg = this.scene.make.image({
            key: bgTextureStates.out.texture,
            frame: bgTextureStates.out.frame,
        });
        this.bg.setOrigin(0);
        this.add(this.bg);

        // EDIT: nineslice interactivity issues
        // EDIT: label interactivity doesnt cover whole item
        this.bg.setInteractive({useHandCursor:true});

        this.imgDelimiterLine = this.scene.make.image({
            key: LoaderFileKeys.ui, 
            frame: "rect-2x2-white.png",
        });
        this.imgDelimiterLine.setOrigin(0, 0.5);
        this.imgDelimiterLine.alpha = this.delimiterLineAlpha;
        this.add(this.imgDelimiterLine);

        // buttonBg: 3slice
        this.buttonBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "btn-oval7-bg-out.png",
            leftWidth: 64,
            rightWidth: 64,
        });
        // this.buttonBg.setOrigin(0); // buttonBg has custom origin @see TP
        this.add(this.buttonBg);

        // label (buttonLabel)
        this.label = this.scene.make.text({
            style: labelTextStates.out,
        });
        this.label.setOrigin(0.5);
        this.add(this.label);

        if (!_isMobile) {
            this.AddViewDef({
                view: this.label,
                textStates: labelTextStates,
            });
        }
    }

    public override RegisterListeners(): void {
        // this.AddListeners();
        this.bg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.OnButtonUp, this);
    }

    public override UnregisterListeners(): void {
        // this.RemoveListeners();
        this.bg.off(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.OnButtonUp, this);
    }

    private OnButtonUp(): void {
        // console.log("click",this.label.text);

        // dispatch change
        this.onItemButtonClick?.(this.itemLayoutData.id);
    }

    public override UpdateViewFromDataChange(
        itemLocData: OptionsItemLocData = undefined,
        itemLiveData: OptionsItemLiveData = undefined
    ): void {
        this.imgDelimiterLine.visible = this.hasDelimiterLine;

        if (itemLocData != undefined) {
            this.label.text = itemLocData.itemLabel;
        }
    }
    
    public override SetWidthGetHeight(width: number): number {
        const sidePaddingsSize = 2 * this.borderPadding.horizontal;
        this.buttonBg.width = width - sidePaddingsSize;
        this.label.style.setWordWrapWidth(width - sidePaddingsSize);
        const height = this.borderPadding.vertical + Math.max(this.buttonBg.height, this.label.displayHeight) + this.borderPadding.vertical;
        
        return height;
    }

    public override OnResize(): void {
        this.bg.setDisplaySize(this.size.width, this.size.height);
        if (this.hasDelimiterLine) {
            this.imgDelimiterLine.y = this.size.height;
            this.imgDelimiterLine.displayWidth = this.size.width;
        }
        this.buttonBg.setPosition(this.size.width * 0.5, this.size.height * 0.5);
        this.label.setPosition(this.size.width * 0.5, this.size.height * 0.5 - 6);
    }
}